import React from 'react';
import Tips from '../components/tips';
import {useAppSelector} from '../redux';
// import '../components/tips/index.scss';

export default function TipsPage() {
    return (
        <div style={{padding: '0 10px'}}>
            <Tips/>
        </div>
    );
}
